import { h } from 'preact';

const ArrowLeft = (props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" {...props}>
			<path fill-rule="evenodd" clip-rule="evenodd" d="M3.68995 14.9832L12.2751 7.43306C12.4624 7.24506 12.5676 6.99046 12.5676 6.72505C12.5676 6.45963 12.4624 6.20504 12.2751 6.01704C12.0871 5.82969 11.8325 5.72449 11.5671 5.72449C11.3017 5.72449 11.0471 5.82969 10.8591 6.01704L0.567894 15.2762C0.177887 15.6682 0.177887 16.3002 0.567894 16.6922L10.8591 25.9834C11.0472 26.1705 11.3017 26.2755 11.5671 26.2755C11.8324 26.2755 12.0869 26.1705 12.2751 25.9834C12.4624 25.7953 12.5676 25.5408 12.5676 25.2753C12.5676 25.0099 12.4624 24.7553 12.2751 24.5673L3.68995 16.9832H31.2754C31.5406 16.9832 31.795 16.8779 31.9825 16.6903C32.17 16.5028 32.2754 16.2484 32.2754 15.9832C32.2754 15.718 32.17 15.4636 31.9825 15.2761C31.795 15.0885 31.5406 14.9832 31.2754 14.9832L3.68995 14.9832Z" />
		</svg>
	);
};

export default ArrowLeft;
